class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.grid = /** @type {HTMLElement | null} */ (this.querySelector('.infinite-scroll__grid'));
    this.loader = /** @type {HTMLElement | null} */ (this.querySelector('.infinite-scroll__loader'));
    this.endMessage = /** @type {HTMLElement | null} */ (this.querySelector('.infinite-scroll__end-message'));
    
    this.collectionUrl = this.dataset.collectionUrl;
    this.currentPage = 1;
    this.isLoading = false;
    this.hasMore = true;

    this.initObserver();
  }

  initObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 400px 0px', // Trigger 400px before reaching the bottom
      threshold: 0.1
    };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
    if (this.loader) {
      this.observer.observe(this.loader);
    }
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  async handleIntersect(entries) {
    const entry = entries[0];
    if (entry && entry.isIntersecting && !this.isLoading && this.hasMore) {
      this.loadMoreProducts();
    }
  }

  async loadMoreProducts() {
    this.isLoading = true;
    this.currentPage++;

    try {
      const fetchUrl = `${this.collectionUrl}?page=${this.currentPage}`;
      const response = await fetch(fetchUrl);
      
      if (!response.ok) throw new Error('Network response was not ok');
      
      const htmlText = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlText, 'text/html');
      
      const newGrid = htmlDocument.querySelector('.infinite-scroll__grid');
      
      if (newGrid && newGrid.children.length > 0) {
        // Extract new items and append them
        const newItems = Array.from(newGrid.children);
        newItems.forEach(item => {
          if (this.grid) this.grid.appendChild(item);
        });
        
        // Check if there's a next page. Shopify returns empty or smaller grids when done.
        // A simple heuristic is if we loaded fewer items than the limit, we're done.
        const limit = parseInt(this.dataset.limit || '12') || 12;
        if (newItems.length < limit) {
          this.reachedEnd();
        }
      } else {
        this.reachedEnd();
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      // On error, let the user try again by scrolling up and down, so we don't permanently disable
    } finally {
      this.isLoading = false;
    }
  }

  reachedEnd() {
    this.hasMore = false;
    if (this.loader) this.loader.style.display = 'none';
    if (this.endMessage) this.endMessage.style.display = 'block';
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
